import { useFormContext } from 'react-hook-form';
import { TxCustomerInput } from '@features/components/CaseFormBlocks/components';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { TxCustomer } from '@/api/apis/customer';
import { NO_COORDINATOR_ID } from '@/api/apis/case';

type Props = {
  contactsList: TxCustomer[];
  currentCoordinator: TxCustomer | undefined;
  disabled: boolean;
  hasPermission?: boolean;
  isOpoRequest?: boolean;
  txCenterId?: string;
};

export const CaseCoordinatorInput = ({
  contactsList,
  currentCoordinator,
  disabled,
  hasPermission = true,
  isOpoRequest,
  txCenterId,
}: Props) => {
  const { setValue } = useFormContext<CaseFormType>();

  const onSelectCoordinator = (coordinator: TxCustomer | null) => {
    const newId = coordinator?.id ?? null;
    const isNoCoordinator = newId === NO_COORDINATOR_ID;

    setValue('coordinatorId', newId);
    setValue('isServiceWithoutCoordinator', isNoCoordinator);
  };

  const onClear = () => {
    setValue('coordinatorId', '', { shouldValidate: true });
    setValue('isServiceWithoutCoordinator', false);
  };

  return (
    <TxCustomerInput
      txCenterId={txCenterId}
      isOpoRequest={isOpoRequest}
      isCoordinator
      contactsList={contactsList}
      disabled={!hasPermission || disabled}
      contactFieldName="coordinatorId"
      contactFieldPlaceholder="TX Center Coordinator"
      defaultValue={currentCoordinator}
      isClearable
      onClear={onClear}
      onSelect={onSelectCoordinator}
    />
  );
};
